import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import actions from './action'
import getters from './getters'
import createVuexAlong from "vuex-along";

Vue.use(Vuex);
// const globalBG = "#2062E7"
// const globalBG ="#202A3B"
const globalBG = "#1F4287"
const globalBG1 = "#909399"
const globalBG2 = "#f56c6c"
const globalBG3 = "#ffffff"

const powerScoreList = [
  // 会员权益 根据索引 0 潜在 1 一星 2 二星。。。
  [
    {
      name: "购物送积分",
      imageUrl: require("@/assets/images/btn_power1_n.png"),
      link: "",
      id: 1,
    },
    {
      name: "新人优惠券",
      imageUrl: require("@/assets/images/btn_power2_n.png"),
      link: "https://yphy-isv.isvjcloud.com/point-h5/discount_coupon?index=1",
      id: 2,
    },
    {
      name: "会员券",
      imageUrl: require("@/assets/images/btn_power3_n.png"),
      link: "https://yphy-isv.isvjcloud.com/point-h5/discount_coupon?index=2",
      id: 3,
    },
    {
      name: "积分兑换",
      imageUrl: require("@/assets/images/btn_power4_n.png"),
      link: "https://yphy-isv.isvjcloud.com/point-h5/IntegralStore?index=3",
      id: 4,
    },
  ],
  [
    {
      name: "购物送积分",
      imageUrl: require("@/assets/images/btn_power1_n.png"),
      link: "",
      id: 1,
    },
    {
      name: "新人优惠券",
      imageUrl: require("@/assets/images/btn_power2_n.png"),
      link: "https://yphy-isv.isvjcloud.com/point-h5/discount_coupon?index=1",
      id: 2,
    },
    {
      name: "会员券",
      imageUrl: require("@/assets/images/btn_power3_n.png"),
      link: "https://yphy-isv.isvjcloud.com/point-h5/discount_coupon?index=2",
      id: 3,
    },
    {
      name: "积分兑换",
      imageUrl: require("@/assets/images/btn_power4_n.png"),
      link: "https://yphy-isv.isvjcloud.com/point-h5/IntegralStore?index=3",
      id: 4,
    },
  ],
  [
    {
      name: "购物送积分",
      imageUrl: require("@/assets/images/btn_power1_n.png"),
      link: "",
      id: 1,
    },
    {
      name: "新人优惠券",
      imageUrl: require("@/assets/images/btn_power2_n.png"),
      link: "https://yphy-isv.isvjcloud.com/point-h5/discount_coupon?index=1",
      id: 2,
    },
    {
      name: "会员券",
      imageUrl: require("@/assets/images/btn_power3_n.png"),
      link: "https://yphy-isv.isvjcloud.com/point-h5/discount_coupon?index=2",
      id: 3,
    },
    {
      name: "积分兑换",
      imageUrl: require("@/assets/images/btn_power4_n.png"),
      link: "https://yphy-isv.isvjcloud.com/point-h5/IntegralStore?index=3",
      id: 4,
    },
  ],
  [
    {
      name: "购物送积分",
      imageUrl: require("@/assets/images/btn_power1_n.png"),
      link: "",
      id: 1,
    },
    {
      name: "新人优惠券",
      imageUrl: require("@/assets/images/btn_power2_n.png"),
      link: "https://yphy-isv.isvjcloud.com/point-h5/discount_coupon?index=1",
      id: 2,
    },
    {
      name: "会员券",
      imageUrl: require("@/assets/images/btn_power3_n.png"),
      link: "https://yphy-isv.isvjcloud.com/point-h5/discount_coupon?index=2",
      id: 3,
    },
    {
      name: "积分兑换",
      imageUrl: require("@/assets/images/btn_power4_n.png"),
      link: "https://yphy-isv.isvjcloud.com/point-h5/IntegralStore?index=3",
      id: 4,
    },
  ],
  [
    {
      name: "购物送积分",
      imageUrl: require("@/assets/images/btn_power1_n.png"),
      link: "",
      id: 1,
    },
    {
      name: "新人优惠券",
      imageUrl: require("@/assets/images/btn_power2_n.png"),
      link: "https://yphy-isv.isvjcloud.com/point-h5/discount_coupon?index=1",
      id: 2,
    },
    {
      name: "会员券",
      imageUrl: require("@/assets/images/btn_power3_n.png"),
      link: "https://yphy-isv.isvjcloud.com/point-h5/discount_coupon?index=2",
      id: 3,
    },
    {
      name: "积分兑换",
      imageUrl: require("@/assets/images/btn_power4_n.png"),
      link: "https://yphy-isv.isvjcloud.com/point-h5/IntegralStore?index=3",
      id: 4,
    },
  ],
  [
    {
      name: "购物送积分",
      imageUrl: require("@/assets/images/btn_power1_n.png"),
      link: "",
      id: 1,
    },
    {
      name: "新人优惠券",
      imageUrl: require("@/assets/images/btn_power2_n.png"),
      link: "https://yphy-isv.isvjcloud.com/point-h5/discount_coupon?index=1",
      id: 2,
    },
    {
      name: "会员券",
      imageUrl: require("@/assets/images/btn_power3_n.png"),
      link: "https://yphy-isv.isvjcloud.com/point-h5/discount_coupon?index=2",
      id: 3,
    },
    {
      name: "积分兑换",
      imageUrl: require("@/assets/images/btn_power4_n.png"),
      link: "https://yphy-isv.isvjcloud.com/point-h5/IntegralStore?index=3",
      id: 4,
    },
  ],
];
// 会员权益的tab栏选中
let selectPowerItem = 0;

// 设置全局变量
const state = {
  isMemberSystemInfo: false,
  // 店铺信息
  sellerData: {},
  // 一级菜单
  fistMenuList: [],
  fistActIndex: 0,
  activeMenu: 0,
  // 二级菜单
  childMenuList: [],
  MemberSystemInfo: {}, // 会员体系详情
  // 为全渠道加的
  pathNow: [],
  route: [],
  topPx: 0,
  stepBack: 0,
  defaultRoute: [], // 默认路由数据
  test: '初始数据',
  SellerSignData: "",
  globalBG: globalBG,
  globalBG1: globalBG1,
  globalBG2: globalBG2,
  globalBG3: globalBG3,
  userRoute: [],//获取的路由
  menuNow: {
    level0: { id: 0, pid: 0 },
    level1: { id: 0, pid: 0 },
    level2: { id: 0, pid: 0 }
  },
  ROI: "1:0.0",
  modelName: {
    flag: false,
    type: '',
    name: '',
    chirdrenName: ''
  },
  otherRight: [],//其它权限
  careRight: [],
  Warenauswahl: 1,
  assignList: [],
  excludeList: [],
  locstart: '',//前进后退路由
  newmenuNow: {
    level0: { id: 0, pid: 0 },
    level1: { id: 0, pid: 0 },
    level2: { id: 0, pid: 0 }
  },//前进后退状态
  leftNavActive: sessionStorage.getItem('leftNavActive') || 0,
  selectGoodsStore: {},
  // 选择创建店铺的数据
  selectShopObj: {
    name: '',
    scoresCardSellerId: ''
  }, // 选择创建店铺
  // 当前选中的页面 1 会员首页 2 积分任务 3 积分乐园 4 积分商城 5 个人中心
  selectPage: 1,
  // 每个页面对应的配置项数据
  pageConfig: {
    // 会员首页
    menberPage: {
      currentCrad: {
        card: require("@/assets/images/card_bg1.png"),
        id: 1,
      },
      color: "#4F3407", //文字颜色
      bgColor: "#ffffff", //文字背景颜色
      // 添加到页面中的组件列表
      pageComponents: [],
      // 会员权益的tab栏选中
      selectPowerItem: 0,
      powerScoreList: powerScoreList,
      // 存储会员权益列表
      powerList: powerScoreList[selectPowerItem],
      // 存储热门互动列表
      hotList: [
        // {
        //   name: "日历签到",
        //   id: 1,
        //   desc: "天天爱签到",
        //   imageUrl: require("@/assets/images/hot_rlqd.png"),
        //   color: "#77C8FE",
        //   visibility: true,
        // },
        // {
        //   name: "完善信息",
        //   id: 2,
        //   desc: "浏览商品享好礼",
        //   imageUrl: require("@/assets/images/hot_wsxx.png"),
        //   color: "#46BFBB",
        //   visibility: true,
        // },
        // {
        //   name: "每日抢好礼",
        //   id: 3,
        //   desc: "蹲点抢大礼包",
        //   imageUrl: require("@/assets/images/hot_mrq.png"),
        //   color: "#FE8577",
        //   visibility: true,
        // },
        // {
        //   name: "关注店铺有礼",
        //   id: 4,
        //   desc: "关注店铺享好礼",
        //   imageUrl: require("@/assets/images/hot_gzdp.png"),
        //   color: "#FFA447",
        //   visibility: true,
        // },
      ],
      // 存储兑换精选列表
      exchangeList: [
        {
          name: "小米小爱音箱Pro1",
          int: "12000",
          imageUrl: require("@/assets/images/dh_goods.png"),
          id: 1,
          visibility: true,
        },
        {
          name: "小米小爱音箱Pro2",
          int: "12000",
          imageUrl: require("@/assets/images/dh_goods.png"),
          id: 2,
          visibility: true,
        },
        {
          name: "小米小爱音箱Pro3",
          int: "12000",
          imageUrl: require("@/assets/images/dh_goods.png"),
          id: 3,
          visibility: true,
        },
      ],
      // 右侧配置显示对应 0 头部 1 权益配置 2 热门互动 3 兑换精选
      configState: null,
      // 会员页面模块是否隐藏间隙的显示状态
      pageHideGaps: false,
      // 卡面列表
      cradList: [
        {
          name: "尊贵黄金",
          imageUrl: require("@/assets/images/card_bg1.png"),
          id: 1,
        },
        {
          name: "永恒黑暗",
          imageUrl: require("@/assets/images/card_bg2.png"),
          id: 2,
        },
        {
          name: "什么白银",
          imageUrl: require("@/assets/images/card_bg3.png"),
          id: 3,
        },
      ],
      // 背景图列表
      bgImageList: [
        {
          name: "暗黑",
          imageUrl: require("@/assets/images/head_bg1.png"),
          id: 1,
        },
        {
          name: "白银",
          imageUrl: require("@/assets/images/head_bg2.png"),
          id: 2,
        },
        {
          name: "黄金",
          imageUrl: require("@/assets/images/head_bg3.png"),
          id: 3,
        },
      ],
      // 当前背景图`
      currentImage: {
        src: require("@/assets/images/head_bg1.png"),
        id: 1,
      },
    },
    // 积分任务
    integralTask: {
      backgroundSrc: require("@/assets/images/integralTask_bg1.jpg"),
      uploadIcon: require("@/assets/images/icon_upload.png"),
      pageComponents: [
        // 等级积分设置的组件，不需要拖拽添加直接写死
        { id: 99, hideGaps: false, select: false, intRecord: true },
      ],
      activityList: [
        {
          id: 11,
          imageUrl: require("@/assets/images/icon_lxqd.png"),
          activityName: "连续签到",
          desc: "天天爱签到",
          startTime: "2019.02.25",
          endTime: "2019.06.30",
          link: "",
          visibility: true,
          activityType: 0,
        },
        // {
        //   id: 12,
        //   imageUrl: require("@/assets/images/icon_mrqhl.png"),
        //   activityName: "每日抢好礼",
        //   desc: "每日抢好礼",
        //   startTime: "2019.02.25",
        //   endTime: "2019.06.30",
        //   link: "",
        //   visibility: true,
        // },
        {
          id: 13,
          imageUrl: require("@/assets/images/icon_gzdp.png"),
          activityName: "关注店铺",
          desc: "天天关注店铺",
          startTime: "2019.02.25",
          endTime: "2019.06.30",
          link: "",
          visibility: true,
          activityType: 3,
        },
        {
          id: 14,
          imageUrl: require("@/assets/images/icon_yqkk.png"),
          activityName: "邀请开卡",
          desc: "邀请开卡",
          startTime: "2019.02.25",
          endTime: "2019.06.30",
          link: "",
          visibility: true,
          activityType: 4,
        },
        // {
        //   id: 15,
        //   imageUrl: require("@/assets/images/icon_yqgzdp.png"),
        //   activityName: "邀请关注店铺",
        //   desc: "天天邀请关注店铺",
        //   startTime: "2019.02.25",
        //   endTime: "2019.06.30",
        //   link: "",
        //   visibility: true,
        // },
      ],
      // 右侧配置显示对应 0 头部背景 1等级积分  3 活动列表
      configState: null,
      // 会员页面模块是否隐藏间隙的显示状态
      pageHideGaps: false,
    },
    // 积分乐园

    integralPlay: {
      backgroundSrc: require("@/assets/images/integralPlay_bg.jpg"),
      uploadIcon: require("@/assets/images/icon_upload.png"),
      pageComponents: [
        // 等级积分设置的组件，不需要拖拽添加直接写死
        { id: 99, hideGaps: false, select: false, intRecord: true },
      ],
      playList: [
        {
          id: 22,
          imageUrl: require("@/assets/images/icon_dzpcj.png"),
          name: "大转盘抽奖",
          desc: "转出好运",
          startTime: "2019.02.25",
          endTime: "2019.06.30",
          visibility: true,
        },
      ],
      configState: null,
      pageHideGaps: false,
    },
    // 积分商城
    integralShop: {
      backgroundSrc: require("@/assets/images/integralShop_bg.jpg"),
      uploadIcon: require("@/assets/images/icon_upload.png"),
      pageComponents: [
        // 等级积分设置的组件，不需要拖拽添加直接写死
        { id: 99, hideGaps: false, select: false, intRecord: true },
      ],
      // 实物列表
      actualList: [
        {
          id: 33,
          imageUrl: require("@/assets/images/dh_goods.png"),
          goodName: "小米 AloT路由器",
          desc: "天天爱小米 AloT路由器",
          startTime: "2019.02.25",
          endTime: "2019.06.30",
          link: "",
          visibility: true,
        },
        {
          id: 34,
          imageUrl: require("@/assets/images/dh_goods.png"),
          goodName: "小米 AloT路由器",
          desc: "天天爱小米 AloT路由器",
          startTime: "2019.02.25",
          endTime: "2019.06.30",
          link: "",
          visibility: true,
        },
        {
          id: 35,
          imageUrl: require("@/assets/images/dh_goods.png"),
          goodName: "小米 AloT路由器",
          desc: "天天爱小米 AloT路由器",
          startTime: "2019.02.25",
          endTime: "2019.06.30",
          link: "",
          visibility: true,
        },
      ],
      // 兑换券列表
      couponList: [
        {
          id: 36,
          imageUrl: require("@/assets/images/icon_coupon.png"),
          goodName: "积分兑换优惠券",
          desc: "剩余100份",
          startTime: "2019.02.25",
          endTime: "2019.06.30",
          link: "",
          visibility: true,
        },
        {
          id: 37,
          imageUrl: require("@/assets/images/icon_coupon.png"),
          goodName: "积分兑换优惠券",
          desc: "剩余100份",
          startTime: "2019.02.25",
          endTime: "2019.06.30",
          link: "",
          visibility: true,
        },
        {
          id: 38,
          imageUrl: require("@/assets/images/icon_coupon.png"),
          goodName: "积分兑换优惠券",
          desc: "剩余100份",
          startTime: "2019.02.25",
          endTime: "2019.06.30",
          link: "",
          visibility: true,
        },
      ],
      configState: null,
      pageHideGaps: false,
    },
    // 个人中心
    personalCenter: {
      backgroundSrc: require("@/assets/images/personalCenter_bg.jpg"),
      pageComponents: [],
      // 明细列表
      detailedList: [
        {
          id: 55,
          imageUrl: require("@/assets/images/icon_personalCenter1.png"),
          name: "积分明细",
        },
        {
          id: 56,
          imageUrl: require("@/assets/images/icon_personalCenter2.png"),
          name: "活动记录",
        },
        {
          id: 57,
          imageUrl: require("@/assets/images/icon_personalCenter3.png"),
          name: "兑换记录",
        },
      ],
      configState: null,
      pageHideGaps: false,
    },
  },
  pageConfigtwo: {
    // 会员首页
    menberPage: {
      currentCrad: {
        card: require("@/assets/images/card_bg1.png"),
        id: 1,
      },
      color: "#4F3407", //文字颜色
      bgColor: "#ffffff", //文字背景颜色
      // 添加到页面中的组件列表
      pageComponents: [
        { id: 99, hideGaps: false, select: false, intRecord: true },
        { id: 1, hideGaps: false, select: false, intRecord: true },
        { id: 2, hideGaps: false, select: false, intRecord: true },
        { id: 3, hideGaps: false, select: false, intRecord: true },
      ],
      // 会员权益的tab栏选中
      selectPowerItem: 0,
      powerScoreList: [...powerScoreList],
      // 存储会员权益列表
      powerList: powerScoreList[selectPowerItem],
      // 存储热门互动列表
      hotList: [
        {
          name: "日历签到",
          id: 1,
          desc: "天天爱签到",
          imageUrl: require("@/assets/images/hot_rlqd.png"),
          color: "#77C8FE",
          visibility: true,
          activityType: 0,
        },
        // {
        //   name: "完善信息",
        //   id: 2,
        //   desc: "浏览商品享好礼",
        //   imageUrl: require("@/assets/images/hot_wsxx.png"),
        //   color: "#46BFBB",
        //   visibility: true,
        // },
        // {
        //   name: "每日抢好礼",
        //   id: 3,
        //   desc: "蹲点抢大礼包",
        //   imageUrl: require("@/assets/images/hot_mrq.png"),
        //   color: "#FE8577",
        //   visibility: true,
        // },
        {
          name: "关注店铺有礼",
          id: 4,
          desc: "关注店铺享好礼",
          imageUrl: require("@/assets/images/hot_gzdp.png"),
          color: "#FFA447",
          visibility: true,
          activityType: 3,
        },
      ],
      // 存储兑换精选列表
      exchangeList: [
        {
          name: "小米小爱音箱Pro1",
          int: "12000",
          imageUrl: require("@/assets/images/dh_goods.png"),
          id: 1,
          visibility: true,
        },
        {
          name: "小米小爱音箱Pro2",
          int: "12000",
          imageUrl: require("@/assets/images/dh_goods.png"),
          id: 2,
          visibility: true,
        },
        {
          name: "小米小爱音箱Pro3",
          int: "12000",
          imageUrl: require("@/assets/images/dh_goods.png"),
          id: 3,
          visibility: true,
        },
      ],
      // 右侧配置显示对应 0 头部 1 权益配置 2 热门互动 3 兑换精选
      configState: null,
      // 会员页面模块是否隐藏间隙的显示状态
      pageHideGaps: false,
      // 卡面列表
      cradList: [
        {
          name: "尊贵黄金",
          imageUrl: require("@/assets/images/card_bg1.png"),
          id: 1,
        },
        {
          name: "永恒黑暗",
          imageUrl: require("@/assets/images/card_bg2.png"),
          id: 2,
        },
        {
          name: "什么白银",
          imageUrl: require("@/assets/images/card_bg3.png"),
          id: 3,
        },
      ],
      // 背景图列表
      bgImageList: [
        {
          name: "暗黑",
          imageUrl: require("@/assets/images/head_bg1.png"),
          id: 1,
        },
        {
          name: "白银",
          imageUrl: require("@/assets/images/head_bg2.png"),
          id: 2,
        },
        {
          name: "黄金",
          imageUrl: require("@/assets/images/head_bg3.png"),
          id: 3,
        },
      ],
      // 当前背景图
      currentImage: {
        src: require("@/assets/images/head_bg1.png"),
        id: 1,
      },
    },
    // 积分任务
    integralTask: {
      backgroundSrc: require("@/assets/images/integralTask_bg1.jpg"),
      uploadIcon: require("@/assets/images/icon_upload.png"),
      pageComponents: [
        // 等级积分设置的组件，不需要拖拽添加直接写死
        { id: 99, hideGaps: false, select: false, intRecord: true },
        { id: 4, hideGaps: false, select: false, intRecord: true },
      ],
      activityList: [
        {
          id: 11,
          imageUrl: require("@/assets/images/icon_lxqd.png"),
          activityName: "连续签到",
          desc: "连续签到",
          startTime: "2019.02.25",
          endTime: "2019.06.30",
          link: "",
          visibility: true,
          activityType: 0,
        },
        // {
        //   id: 12,
        //   imageUrl: require("@/assets/images/icon_mrqhl.png"),
        //   activityName: "每日抢好礼",
        //   desc: "每日抢好礼",
        //   startTime: "2019.02.25",
        //   endTime: "2019.06.30",
        //   link: "",
        //   visibility: true,
        // },
        {
          id: 13,
          imageUrl: require("@/assets/images/icon_gzdp.png"),
          activityName: "关注店铺",
          desc: "关注店铺",
          startTime: "2019.02.25",
          endTime: "2019.06.30",
          link: "",
          visibility: true,
          activityType: 3,
        },
        {
          id: 14,
          imageUrl: require("@/assets/images/icon_yqkk.png"),
          activityName: "邀请开卡",
          desc: "邀请开卡",
          startTime: "2019.02.25",
          endTime: "2019.06.30",
          link: "",
          visibility: true,
          activityType: 4,
        },
        // {
        //   id: 15,
        //   imageUrl: require("@/assets/images/icon_yqgzdp.png"),
        //   activityName: "邀请关注店铺",
        //   desc: "邀请关注店铺",
        //   startTime: "2019.02.25",
        //   endTime: "2019.06.30",
        //   link: "",
        //   visibility: true,
        // },
      ],
      // 右侧配置显示对应 0 头部背景 1等级积分  3 活动列表
      configState: null,
      // 会员页面模块是否隐藏间隙的显示状态
      pageHideGaps: false,
    },
    // 积分乐园
    integralPlay: {
      backgroundSrc: require("@/assets/images/integralPlay_bg.jpg"),
      uploadIcon: require("@/assets/images/icon_upload.png"),
      pageComponents: [
        // 等级积分设置的组件，不需要拖拽添加直接写死
        { id: 99, hideGaps: false, select: false, intRecord: true },
        { id: 5, hideGaps: false, select: false, intRecord: true },
      ],
      playList: [
        {
          id: 22,
          imageUrl: require("@/assets/images/icon_dzpcj.png"),
          name: "大转盘抽奖",
          desc: "转出好运",
          startTime: "2019.02.25",
          endTime: "2019.06.30",
          visibility: true,
        },
      ],
      configState: null,
      pageHideGaps: false,
    },
    // 积分商城
    integralShop: {
      backgroundSrc: require("@/assets/images/integralShop_bg.jpg"),
      uploadIcon: require("@/assets/images/icon_upload.png"),
      pageComponents: [
        // 等级积分设置的组件，不需要拖拽添加直接写死
        { id: 99, hideGaps: false, select: false, intRecord: true },
        { id: 8, hideGaps: false, select: false, intRecord: true },
      ],
      // 实物列表
      actualList: [
        {
          id: 33,
          imageUrl: require("@/assets/images/dh_goods.png"),
          goodName: "小米 AloT路由器",
          desc: "天天爱小米 AloT路由器",
          startTime: "2019.02.25",
          endTime: "2019.06.30",
          link: "",
          visibility: true,
        },
        {
          id: 34,
          imageUrl: require("@/assets/images/dh_goods.png"),
          goodName: "小米 AloT路由器",
          desc: "天天爱小米 AloT路由器",
          startTime: "2019.02.25",
          endTime: "2019.06.30",
          link: "",
          visibility: true,
        },
        {
          id: 35,
          imageUrl: require("@/assets/images/dh_goods.png"),
          goodName: "小米 AloT路由器",
          desc: "天天爱小米 AloT路由器",
          startTime: "2019.02.25",
          endTime: "2019.06.30",
          link: "",
          visibility: true,
        },
      ],
      // 兑换券列表
      couponList: [
        {
          id: 36,
          imageUrl: require("@/assets/images/icon_coupon.png"),
          goodName: "积分兑换优惠券",
          desc: "剩余100份",
          startTime: "2019.02.25",
          endTime: "2019.06.30",
          link: "",
          visibility: true,
        },
        {
          id: 37,
          imageUrl: require("@/assets/images/icon_coupon.png"),
          goodName: "积分兑换优惠券",
          desc: "剩余100份",
          startTime: "2019.02.25",
          endTime: "2019.06.30",
          link: "",
          visibility: true,
        },
        {
          id: 38,
          imageUrl: require("@/assets/images/icon_coupon.png"),
          goodName: "积分兑换优惠券",
          desc: "剩余100份",
          startTime: "2019.02.25",
          endTime: "2019.06.30",
          link: "",
          visibility: true,
        },
      ],
      configState: null,
      pageHideGaps: false,
    },
    // 个人中心
    personalCenter: {
      backgroundSrc: require("@/assets/images/personalCenter_bg.jpg"),
      pageComponents: [
        { id: 99, hideGaps: false, select: false, intRecord: true },
        { id: 10, hideGaps: false, select: false, intRecord: true },
      ],
      // 明细列表
      detailedList: [
        {
          id: 55,
          imageUrl: require("@/assets/images/icon_personalCenter1.png"),
          name: "积分明细",
        },
        {
          id: 56,
          imageUrl: require("@/assets/images/icon_personalCenter2.png"),
          name: "活动记录",
        },
        {
          id: 57,
          imageUrl: require("@/assets/images/icon_personalCenter3.png"),
          name: "兑换记录",
        },
      ],
      configState: null,
      pageHideGaps: false,
    },
  },
  // 存储当前选中的链接项
  curLinkItem: "",
  //要设置的初始属性值
  scaleValue: 1, // 页面适配scale值
  isIframe: false, // 是否在iframe中
};
export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
  plugins: [
    createVuexAlong({
      name: "userDataNow", // 设置保存的集合名字，避免同站点下的多项目数据冲突
      session: {
        list: ['sellerData'],
      }
    })
  ]
})
